import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from 'axios';
import Paginator from "../../components/Paginator";
import InnerNav from "../../components/InnerNav";
import Wrapper from "../../components/Wrapper";
import { AiFillEdit, AiFillDelete } from "react-icons/ai";
const Registerjackpot = ()=>{
    const [registerJackpot, setRegisterJackpot] = useState([]);
    const [page, setPage] = useState(1);
    const [lastPage, setLastPage] = useState(1);
   
    useEffect(() => {
        const fetchData = async () => {
            try {
                const { data } = await axios.get(`registerJackpot?page=${page}`);
                setRegisterJackpot(data.data || []);
                setLastPage(data.meta.last_page || 1);
            } catch (error) {
                console.error("Error fetching data:", error);
                setRegisterJackpot([]);
            }
        };

        fetchData();
    }, [page]);
    const del = async (id) =>{
        if(window.confirm("Are you sure you want to delete this record?")){
            await axios.delete(`registerjackpot/${id}`);
            setRegisterJackpot(registerJackpot.filter((registerjackpot) => registerjackpot.id !== id));
        }
    }
    return (
        <Wrapper pageTitle={'Registerjackpot'}>
            <InnerNav createLink={'/registerjackpotCreate'} listLink={'/registerjackpot'} />
                <div className="w-full overflow-hidden rounded-lg shadow-xs">
                    <div className="w-full overflow-x-auto">
                        <table className="w-full whitespace-no-wrap">
                            <thead>
                                <tr className="text-xs font-semibold tracking-wide text-left text-gray-500 uppercase border-b dark:border-gray-700 bg-gray-50 dark:text-gray-400 dark:bg-gray-800" >
                                    <th className="px-4 py-3">#Ref </th>
                                    <th className="px-4 py-3">Jackpot Name </th>
                                    <th className="px-4 py-3">Period </th>
                                    <th className="px-4 py-3">Date-Hour </th>
                                    <th className="px-4 py-3">Amount </th>
                                     <th className="px-4 py-3">Action</th>
                                </tr>
                                </thead>
                                <tbody className="bg-white divide-y dark:divide-gray-700 dark:bg-gray-800" >
                                    {registerJackpot.map((rj)=>{
                                         return(
                                             <tr key={rj.id} className="text-gray-700 dark:text-gray-400">
                                                 <td className="px-4 py-5">{rj.id}</td>
                                                 <td className="px-4 py-3 text-sm">{rj.jackpot_name}</td>
                                                 <td className="px-4 py-3 text-sm">{rj.period}</td>
                                                 <td className="px-4 py-3 text-sm">{rj.date_hour}</td>
                                                 <td className="px-4 py-3 text-sm">{rj.amount}</td>
                                                 <td className="flex px-4 py-3 text-sm"><Link className="btn btn-sm btn-outline-secondary px-5" to={`/registerjackpot/${rj.id}/edit`}><AiFillEdit/> </Link><span className="btn btn-sm btn-outline-secondary" onClick={()=>del(rj.id)}> <AiFillDelete className="text-rose-500 text-lg"/></span></td>
                                             </tr>
                                         );
                                     })
                                 }
                            </tbody>
                        </table>
                    </div>
                    <Paginator lastPage={lastPage} pageChanged={setPage} />
                </div>
             </Wrapper>
         );
};
export default Registerjackpot;